import { useEffect, useState, type FC } from 'react';
import { ImageOff } from 'lucide';

import Avatar from '@mui/material/Avatar';

import Icon from 'common/components/Icon';

/** KIOS không để trống logo mà trả về ảnh chữ "No Logo" — coi như chưa có logo. */
const isPlaceholderLogo = (src: string) => /\/no-logo\.[a-z]+(\?.*)?$/i.test(src);

interface Props {
  src?: string | null;
  size: number;
  alt?: string;
}

/** Logo doanh nghiệp: giữ nguyên tỉ lệ (không cắt), ảnh lỗi/thiếu thì hiện icon "không có ảnh". */
const LogoAvatar: FC<Props> = ({ src, size, alt = '' }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const usable = !!src && !isPlaceholderLogo(src) && !failed;

  return (
    <Avatar
      variant="rounded"
      src={usable ? src : undefined}
      alt={alt}
      imgProps={{ onError: () => setFailed(true), style: { objectFit: 'contain' } }}
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        bgcolor: usable ? 'background.paper' : 'action.hover',
        color: 'text.disabled',
        border: '1px solid',
        borderColor: 'divider',
        p: usable ? 1 : 0,
      }}
    >
      <Icon icon={ImageOff} size={Math.round(size * 0.36)} />
    </Avatar>
  );
};

export default LogoAvatar;
